// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1W2kW","info":"Note_info__118kg","note":"Note_note__2t0iD","actions":"Note_actions__2iV_X"};